import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2

import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import CustomTextField from "../CustomTextField";
import CustomSeachSelect from "../CustomSearchSelect";
import CustomSelect from "../CustomSelect";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { obtenerTemas, obtenerTemasCodocente, obtenerTemasFiltradosCodocente } from "../../Redux/autocompletados";
import TokenContext from "../../context/TokenContext";
import { useDispatch, useSelector } from "react-redux";
import { misGestionesAbiertas, nuevaGestion } from "../../Redux/ghResponde";
import { useState } from "react";
import { MuiFileInput } from "mui-file-input";
import { UserAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import { cargarAdjuntoSolicitud } from "../../Redux/solicitudes";
import { DialogTitle, IconButton } from "@mui/material";
import CustomSearchSelect from "../CustomSearchSelect";

const ModalGestionAbierta = ({ open, handleClose, data }) => {
  const dispatch = useDispatch();
  const token = useContext(TokenContext);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [temas, setTemas] = React.useState([]);
  const temasSelector = useSelector((store) => store.autocompletados.temasCodocente);
  const [temasFiltrados, setTemasFiltrados] = React.useState([]);
  const temasFiltradosSelector = useSelector((store) => store.autocompletados.temasFiltradosCodocente);
  const { empleado } = UserAuth();
  const [selectedFiles, setSelectedFiles] = useState([]);

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile);
  };

  const defaultValues = {
    // empleado: '',
    new_name: "",
    new_tipodeincidencia: null,
    new_tema_primario: null,
    new_tema: null,
    new_descripcion: "",
  };

  const validacionSchema = yup.object().shape({
    // empleado: yup.string().required("Required"),
    new_name: yup.string().required("Por favor escribe el titulo. "),
    new_tipodeincidencia: yup.number().required("Required"),
    new_tema_primario: yup.object({ value: yup.string().required("El tema primario es requerido") }),
    new_tema: yup.object({ value: yup.string().required("El tema es requerido") }),
    new_descripcion: yup.string().required("Por favor escribe la descripción."),
  });

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  });

  const { handleSubmit, setValue, watch } = methods;

  const temaPrimarioSeleccionado = watch('new_tema_primario')

  // Forma más resumida utilizando el operador spread
  React.useEffect(() => {
    if (data) {
      Object.keys(data).forEach((key) => {
        setValue(key, data[key]);
      });
    }
  }, [data, setValue]);


  React.useEffect(() => {
    if (token) {
      dispatch(obtenerTemasCodocente(token));
    }
  }, [token]);

  React.useEffect(() => {
    if (!temaPrimarioSeleccionado) {
      setTemasFiltrados([]);
    }
  }, [temaPrimarioSeleccionado]);

  React.useEffect(() => {
    if (temasSelector?.length > 0) {
      var array = [];
      temasSelector.forEach((element) => {
        var objeto = {
          value: element.new_temaprimarioid,
          label: element.new_name,
        };
        array.push(objeto);
      });
      setTemas(array);
    }
  }, [temasSelector]);

  React.useEffect(() => {
    if (temasFiltradosSelector?.length > 0) {
      setTemasFiltrados((prevTemasFiltrados) => {
        // Hacer una copia del estado actual
        const newArray = [...prevTemasFiltrados];
        
        // Limpiar el array
        newArray.length = 0;
  
        // Llenar el array con los nuevos valores
        temasFiltradosSelector.forEach((element) => {
          newArray.push({
            value: element.new_temaid,
            label: element.new_name,
          });
        });
  
        // Retornar el nuevo array como el nuevo estado
        return newArray;
      });
    } else {
      // Si el resultado del fetch es vacío, establecer temasFiltrados en un array vacío
      setTemasFiltrados([]);
    }
  }, [temasFiltradosSelector]);

  
  const submitDatos = async (datos) => {
    const formData = new FormData();
  
    // Procesar archivos si hay alguno
    if (selectedFiles.length > 0) {
      for (let index = 0; index < selectedFiles.length; index++) {
        if (selectedFiles[index].size >= 15000000) {
          toast.error("El archivo no puede superar los 15 megas", {
            theme: "dark",
            position: "top-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setSelectedFiles([]);
          return;
        }
        let element = selectedFiles[index];
        formData.append(`body${index}`, element);
      }
    }
  
    if (token) {
      try {
        const id = await dispatch(
          nuevaGestion(empleado.empleadoid, datos, token)
        );
  
        // Ejecutar dispatch solo si hay archivos cargados
        if (selectedFiles.length > 0) {
          dispatch(cargarAdjuntoSolicitud(token, formData, id, "gestion"));
        }
  
        dispatch(misGestionesAbiertas(token, empleado.empleadoid));
        handleClose();
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };


  const opcionesTipoGestion = [
    { value: "", label: "Seleccione una opción" },
    { value: 100000000, label: "Pregunta" },
    { value: 100000001, label: "Problema" },
    { value: 100000002, label: "Solicitud" },
  ];

  const handleTemaPrimarioChange = (selectedTemaPrimario) => {
    setValue('new_tema_primario', selectedTemaPrimario); // Actualiza el valor en el useForm
    if (token) {
      dispatch(obtenerTemasFiltradosCodocente(token, selectedTemaPrimario?.value));
    }
  };


  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <FormProvider {...methods}>
        <DialogContent>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} sx={{ pt: 0, pb: 0 }}>
                <CustomTextField
                  fullWidth
                  Component={TextField}
                  name="new_name"
                  label="Título"
                  rules={{ required: "Required!" }}
                  // helperText="Por favor escribe el titulo."
                  req={true}
                  className="custom-helper"
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ pt: 0, pb: 0 }}>
                <CustomSelect
                  fullWidth
                  name="new_tipodeincidencia"
                  label="Tipo de gestión"
                  helperText="Por favor seleccione un valor"
                  options={opcionesTipoGestion}
                  rules={{ required: "Required!" }}
                  req={true}
                  className="custom-helper"
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect
                  options={temas}
                  req="true"
                  type="text"
                  name="new_tema_primario"
                  lab="Tema Primario"
                  helperText="Por favor seleccione un valor"
                  handleChange={handleTemaPrimarioChange}
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ pt: 0, pb: 0 }}>
                <CustomSearchSelect
                  options={temasFiltrados}
                  req="true"
                  type="text"
                  name="new_tema"
                  lab="Tema"
                  helperText="Por favor seleccione un valor"
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ pt: 0, pb: 0 }}>
                <CustomTextField
                  fullWidth
                  Component={TextField}
                  name="new_descripcion"
                  label="Descripción"
                  multiline
                  rules={{ required: "Required!" }}
                  // helperText="Por favor escribe la descripción."
                  req={true}
                  className="custom-helper"
                />
              </Grid>
              <Grid item xs={12} sm={12} sx={{ pt: 0, pb: 0, mt: 2 }}>
                <MuiFileInput
                  fullWidth
                  value={selectedFiles}
                  multiple
                  label="Adjuntar documento"
                  onChange={changeHandler}
                />
              </Grid>
              <Grid sx={{ px: 2, mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ height: "100%" }}>
                    <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                  </Box>
                  <Box sx={{ height: "100%" }}>
                    <Typography>
                      El tamaño máximo permitido por archivo es de 15 MB
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="text" color="secondary" onClick={handleClose}>
                Cerrar
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

export default ModalGestionAbierta;
